import script from "./AssembleTowelPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AssembleTowelPage.vue?vue&type=script&setup=true&lang=js"

import "./AssembleTowelPage.vue?vue&type=style&index=0&id=4b6ada60&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b6ada60"]])

export default __exports__